import { idSchemaV2, isId, isUserId, type UserId, UserIdSchema } from '../ids'
import { z } from 'zod'

export const GameIdSchema = idSchemaV2('Game')
export type GameId = z.infer<typeof GameIdSchema>
export const isGameId = isId(GameIdSchema)
export type WithGameId = {
  gameId: GameId
}

export const GroupIdSchema = idSchemaV2('Group')
export type GroupId = z.infer<typeof GroupIdSchema>
export const isGroupId = isId(GroupIdSchema)

export type GameParticipantId = UserId | GroupId

export const ParticipantIdSchema = z.union([UserIdSchema, GroupIdSchema])
export function isGameParticipantId(val: unknown): val is GameParticipantId {
  return isUserId(val) || isGroupId(val)
}

export const GameParticipantTypeSchema = z.enum(['user', 'group'])
export type GameParticipantType = z.infer<typeof GameParticipantTypeSchema>
